import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    GuardResult,
    MaybeAsync, Router,
    RouterStateSnapshot
} from "@angular/router";
import {inject} from "@angular/core";
import {productHandlingStore} from "../../dashboard-page/components/product-handling/store/product-handling.store";

export const productCloneHandlingGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> => {
    const router = inject(Router);
    const id = Number(route.params['clone']);

    return id === undefined || isNaN(id)
        ? true
        : inject(productHandlingStore).fetchForClone(id);

}